import { Copy, Link2, Link2Off } from 'lucide-react'
import PropTypes from 'prop-types'
import { useCallback, useState } from 'react'

import { Separator } from '@/components/elements/separator'

import { ToolbarButton } from '../toolbar-button'

export const LinkPopoverBlock = ({ url, onClear, onEdit }) => {
  const [copyTitle, setCopyTitle] = useState('Copy')

  const handleCopy = useCallback(
    (e) => {
      e.preventDefault()
      navigator.clipboard
        .writeText(url)
        .then(() => {
          setCopyTitle('Copied!')
          setTimeout(() => setCopyTitle('Copy'), 1000)
        })
        .catch(console.error)
    },
    [url],
  )

  const handleOpenLink = useCallback(() => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }, [url])

  return (
    <div className="bg-background flex h-10 overflow-hidden rounded p-2 shadow-lg">
      <div className="inline-flex items-center gap-1">
        <ToolbarButton tooltip="Edit link" onClick={onEdit} className="w-auto px-2">
          Edit link
        </ToolbarButton>
        <Separator orientation="vertical" />
        <ToolbarButton tooltip="Open link in a new tab" onClick={handleOpenLink}>
          <Link2 className="size-4" />
        </ToolbarButton>
        <Separator orientation="vertical" />
        <ToolbarButton tooltip="Clear link" onClick={onClear}>
          <Link2Off className="size-4" />
        </ToolbarButton>
        <Separator orientation="vertical" />
        <ToolbarButton
          tooltip={copyTitle}
          onClick={handleCopy}
          tooltipOptions={{
            onPointerDownOutside: (e) => {
              if (e.target === e.currentTarget) e.preventDefault()
            },
          }}
        >
          <Copy className="size-4" />
        </ToolbarButton>
      </div>
    </div>
  )
}

LinkPopoverBlock.propTypes = {
  url: PropTypes.string.isRequired,
  onClear: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
}
